// extracted by mini-css-extract-plugin
export var labelWrapper = "_97-0";